module.exports = __webpack_public_path__ + "static/media/mobile_separator_03.a262bf26.webp";